import React from "react";
import { Link } from "react-router-dom";
import "./BackToVehicleModels.css";

const BackToVehicleModels = ({ variant = "light" }) => {
  return (
    <section className={`back-to-models back-to-models--${variant}`}>
      <Link to="/" className="back-to-models-btn">
        <span className="back-to-models-icon" aria-hidden="true">
          ←
        </span>
        Back to Vehicle Models
      </Link>
    </section>
  );
};

export default BackToVehicleModels;
